import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { Form } from "@/components/ui/form";
import { z } from "zod";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import FormInputField from "@/components/lib/from-input-field";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { useEffect, useState } from "react";

export default function CreateExtraCourseItem({
  isOpen,
  onClose,
  title,
  extraItems,
  setExtraItems,
}) {
  const form = useForm({
    resolver: zodResolver(schema),
    mode: "onChange",
    defaultValues: {
      item_id: "",
      extra_charge: "",
    },
  });
  const item_id = form.watch("item_id");
  const [selectedItem, setSelectedItem] = useState(null);
  const [extraAllItems, setAllExtraItems] = useState([]);
  const { itemVariants } = useSelector((state) => state.essentialMenu.variants);

  useEffect(() => {
    const mappedItems = itemVariants.flatMap((course) =>
      course.course_items.map((item) => ({
        ...item,
        unique_id: item.unique_id || uuidv4(),
      }))
    );
    setAllExtraItems(mappedItems);
  }, [itemVariants]);

  useEffect(() => {
    if (item_id) {
      const founItem = extraAllItems?.find(
        (item) => String(item.unique_id) === String(item_id)
      );
      setSelectedItem(founItem);
    } else {
      setSelectedItem(null);
    }
  }, [item_id, extraAllItems]);

  const onSubmit = (data) => {
    try {
      const newItem = {
        name: selectedItem?.name || selectedItem?.menu_item?.name,
        item_id: selectedItem?.item_id,
        item_type: selectedItem?.item_type,
        variant_id: selectedItem?.variant_id,
        price: selectedItem?.price,
        unique_id: selectedItem?.unique_id,
        extra_charge: data?.extra_charge,
        file_manager_id: selectedItem?.file_manager_id,
        quantity: selectedItem?.quantity,
      };
      setExtraItems([...extraItems, newItem]);
      toast.success("Extra charge added successfully!");
      form.reset();
      onClose();
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong.");
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[600px]">
        <div className="py-5 flex flex-col">
          <DialogTitle className="text-lg absolute top-4 font-medium">
            {title || "Create Combo Item"}
          </DialogTitle>
          <Separator className="mt-4" />

          <Form {...form}>
            <form
              onSubmit={form.handleSubmit(onSubmit)}
              className="flex flex-col gap-6 mt-5"
            >
              <div>
                <FormInputField
                  name="item_id"
                  style="bg-cblack3"
                  placeholder="Select Item"
                  form={form}
                  selectOption={
                    extraAllItems && extraAllItems?.length > 0
                      ? extraAllItems?.map((item) => ({
                          label: item?.name || item?.menu_item?.name,
                          value: item.unique_id,
                        }))
                      : [
                          {
                            label: "No option available",
                            value: "",
                            disabled: true,
                          },
                        ]
                  }
                  label="Add Item"
                  search={true}
                  type="select"
                />
              </div>
              <FormInputField
                name="extra_charge"
                style="bg-cblack3"
                placeholder="1"
                form={form}
                label="Extra Price"
                type="text"
              />
              <Button type="submit" className="bg-cyellow w-full text-cblack">
                Confirm
              </Button>
            </form>
          </Form>
        </div>
      </DialogContent>
    </Dialog>
  );
}

const schema = z.object({
  item_id: z.string().min(1, "Add item is required"),
  extra_charge: z.preprocess(
    (val) => {
      if (val === null || val === undefined || val === "") return undefined;
      return Number(val);
    },
    z
      .number({
        invalid_type_error: "Extra charge must be a number",
      })
      .min(1, "Extra charge must be at least 1")
  ),
});
